/**
 * User Story 3 · Scenario 4: if the backend flags the principal as deactivated, the user
 * must be treated as blocked/inactive — the exchange itself still returns 200 OK, so the
 * check is purely on the returned subject.
 */
export function isDeactivatedPrincipal(subject) {
    const user = Object.values(subject?.principal?.user || {})[0];
    return Boolean(user?.deactivated);
}
